<mat-card class="card-item">
  <div class="card-item__thumb">
    <div
      class="card-item__thumb-img"
      [ngClass]="{ blur: !data.id && !hovering && !uploaded }"
      >
      @if (data.thumbnailUri && !hovering && !uploaded) {
        <img
        [ngClass]="{
          blur: !data.id,
          'cursor-pointer':
            data.id &&
            (data.additionalAssetIndex == null ||
              dataType == 'postProduction' ||
              dataType == 'outputAssets')
        }"
          [src]="getLinkImage() | secure | async"
          [alt]="'assets/image-placeholder.jpg'"
          [hidden]="!isImageLoaded"
          (load)="checkImageLoaded()"
        (click)="
          data.id &&
          (data.additionalAssetIndex == null ||
            dataType == 'postProduction' ||
            dataType == 'outputAssets')
            ? onEdit()
            : ''
        "
        (dragover)="
          (dataType == 'outputAssets' && authService.hasPermission(Permission.OutputAssetsFull)) ||
          (dataType == 'postProduction' && authService.hasPermission(Permission.PostAssetsUpload)) ||
          (dataType == 'production' && authService.hasPermission(Permission.ShootAssetsFull))
            ? (hovering = true) : ''
        "
          />
      }
      @if (hovering && !uploaded) {
        <div
          class="file-upload"
          (dragenter)="dragEnter()"
          (dragleave)="dragLeave()"
          (drop)="fileDrop($event)"
          >
          <mat-icon class="icon"> cloud_upload </mat-icon>
          <div class="upload-title">
            {{ dataType == 'outputAssets' ? 'Drop file here to create new output version' : 'Drop files here to upload' }}
          </div>
          @if (dataType == 'outputAssets') {
            <div class="upload-sub-title">
              <i>accepts {{ getFormat().toLowerCase() }} only*</i>
            </div>
          }
          @if (dataType == 'postProduction' || dataType == 'production') {
            <div class="upload-sub-title">
              <i>{{ allowedFormatsHint }}</i>
            </div>
          }
          @if (dataType == 'production') {
            <div class="upload-sub-title">
              <i>accepts .cr3, .jpg, .jpeg, .png, .mov, .mp4</i>
            </div>
          }
          @if (invalidFile) {
            <div class="invalid-upload">
              <mat-icon color="error"> error </mat-icon>
              <div class="upload-sub-title">{{ invalidReason }}</div>
            </div>
          }
        </div>
      }
      @if (uploaded) {
        @if (!invalidFormat) {
          <img
            [src]="newOutputFileImage"
            [alt]="newOutputFile.name"
            />
        } @else {
          <div
            class="file-upload"
          (dragover)="
            dataType == 'outputAssets' && data.postAssetId
              ? (hovering = true)
              : ''
          "
            >
            <div class="upload-title">Unable to display due to format type</div>
            <div class="upload-sub-title">
              <i>{{ getFormat().toLowerCase() }} format*</i>
            </div>
          </div>
        }
        <div class="uploaded-actions">
          <button
            mat-icon-button
            matTooltip="Cancel"
            color="pending"
            (click)="cancel()"
            >
            <mat-icon>cancel</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Confirm"
            color="success"
            (click)="confirm()"
            >
            <mat-icon>check_circle</mat-icon>
          </button>
        </div>
      }
      <input
        type="file"
        #fileInput
        hidden
        onclick="this.value=null"
        (change)="fileUpload(fileInput.files!)"
        [accept]="dataType == 'outputAssets' ? getFormat() : ''"
        />
      @if ((!isImageLoaded || !data.thumbnailUri) && !hovering && !uploaded) {
        @if (!invalidFormat) {
          <div class="card-item__no-img">
            <img
            [ngClass]="{
              'cursor-pointer':
                data.id &&
                (data.additionalAssetIndex == null ||
                  dataType == 'postProduction' ||
                  dataType == 'outputAssets')
            }"
              [src]="'assets/image-placeholder.jpg'"
              alt="Image Error"
              matTooltipPosition="above"
            (click)="
              data.id &&
              (data.additionalAssetIndex == null ||
                dataType == 'postProduction' ||
                dataType == 'outputAssets')
                ? onEdit()
                : ''
            "
            (dragover)="
              (dataType == 'outputAssets' && data.postAssetId && authService.hasPermission(Permission.OutputAssetsFull)) ||
              (dataType == 'postProduction' && authService.hasPermission(Permission.PostAssetsFull)) ||
              (dataType == 'production' && authService.hasPermission(Permission.ShootAssetsFull))
                ? (hovering = true)
                : ''
            "
              />
          </div>
        } @else {
          <div
            class="file-upload"
          (dragover)="
            dataType == 'outputAssets' && data.postAssetId
              ? (hovering = true)
              : ''
          "
            >
            <div class="upload-title">Unable to display due to format type</div>
            <div class="upload-sub-title">
              <i>{{ getFormat().toLowerCase() }} format*</i>
            </div>
          </div>
        }
      }
    </div>
  </div>
  <mat-card-content>
    @switch (dataType) {
      <!-- PRODUCTION -->
      @case ('production') {
        <div class="content-item">
          <div class="card-item__label" [title]="data.label">{{ data.label }}</div>
          <div class="spacer"></div>
          @if (data.id && authService.hasPermission(Permission.ShootAssetsRead)) {
            <div
              class="card-item__description"
              matTooltip="{{ data.shotDate | dateAgo : currentConfigDate : true | async }} by {{ data.shotByUserName }}"
              >
              {{ data.shotDate | dateAgo : currentConfigDate | async }}
            </div>
          }
          @if (!data.id) {
            <div class="card-item__description">Pending</div>
          }
        </div>
        <div class="card-item__key">
          @if (data.enhancementFlag) {
            <i class="material-icons sparkle">auto_awesome</i>
          }
          @if (data.key && authService.hasPermission(Permission.PostAssetsPreRelease)) {
            <mat-icon class="card-item__copy" (click)="copyToClipboard(data.key)">content_copy</mat-icon>
            <span class="card-item__key--text" (click)="copyToClipboard(data.key)">{{ data.key }}</span>
          }
        </div>
      }
      <!-- POST-PRODUCTION -->
      @case ('postProduction') {
        <div class="content-item">
          <div class="card-item__label" [title]="data.label">{{ data.label }}</div>
          <div class="spacer"></div>
          @if (data.id) {
            <div
              class="card-item__description"
              style="text-align: end"
              matTooltip="{{ data.postProcessedDate | dateAgo : currentConfigDate : true | async }} by {{ data.postByUserName }}"
              >
              {{ data.postProcessedDate | dateAgo : currentConfigDate | async }}
            </div>
          }
          @if (!data.id) {
            <div class="card-item__description" style="text-align: end">Pending</div>
          }
        </div>
        @if (data.id) {
          <div class="card-item__sublabel" [title]="data.subLabel">{{ data.subLabel }}</div>
        }
        @if (!data.id && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__sublabel">{{ data.subLabel }}</div>
        }
        @if (data.key && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__key" (click)="copyToClipboard(data.key)">
            <mat-icon class="card-item__copy">content_copy</mat-icon>
            <span class="card-item__key--text">{{ data.key }}</span>
          </div>
        }
        @if (data.manuallyUploaded && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__key">
            <i>manual upload*</i>
          </div>
        }
      }
      <!-- OUTPUT ASSETS -->
      @case ('outputAssets') {
        <div class="content-item">
          <div class="card-item__label" [title]="data.label">{{ data.label }}</div>
          <div class="spacer"></div>
          @if (data.id) {
            <div
              class="card-item__description"
              style="text-align: end"
              matTooltip="{{ data.postProcessedDate | dateAgo : currentConfigDate : true | async }}"
              >
              {{ data.postProcessedDate | dateAgo : currentConfigDate | async }}
            </div>
          }
          @if (!data.id) {
            <div class="card-item__description" style="text-align: end">Pending</div>
          }
        </div>
        @if (outputAssetsSecondary; as ordinal) {
          <div class="card-item__ordinal">
            <span>{{ ordinal }}</span>
            @if (outputAssetsEvChip; as evChip) {
              <span class="card-item__ev-chip">{{ evChip }}</span>
            }
          </div>
        }
        @if (data.id) {
          <div class="card-item__sublabel" [title]="data.subLabel">{{ data.subLabel }}</div>
        }
        @if (!data.id && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__sublabel">{{ data.subLabel }}</div>
        }
        @if (data.key && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__key" (click)="copyToClipboard(data.key)">
            <mat-icon class="card-item__copy">content_copy</mat-icon>
            <span class="card-item__key--text">{{ data.key }}</span>
          </div>
        }
        @if (data.manuallyUploaded && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__key">
            <i>manual upload*</i>
          </div>
        }
      }
      <!-- PRE-PRODUCTION (default) -->
      @default {
        <div class="content-item">
          <div class="card-item__label" [title]="data.label">{{ data.label }}</div>
          <div class="spacer"></div>
          @if (!data.id) {
            <div class="card-item__description" style="text-align: end">Pending</div>
          }
        </div>
        @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__sublabel">{{ data.subLabel }}</div>
        }
        @if (data.key && authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <div class="card-item__key" (click)="copyToClipboard(data.key)">
            <mat-icon class="card-item__copy">content_copy</mat-icon>
            <span class="card-item__key--text">{{ data.key }}</span>
          </div>
        }
      }
    }
  </mat-card-content>
  <mat-card-actions>
    <div class="card-item__actions">
      @if (showParentInfo) {
        <div class="card-item__sub-item">
          Additional Asset of {{ parentLabel }}
        </div>
      }
      @if (!showParentInfo) {
        @if (!!data.id) {
          <mat-checkbox
            class="selected-card"
            [(ngModel)]="data.selected"
            (ngModelChange)="onSelect()"
            [color]="'primary'"
            [disabled]="!data.thumbnailUri"
          ></mat-checkbox>
        }
        @if (showExternalStatus && authService.hasPermission(Permission.PostAssetsPreRelease) && data.id) {
          <div
            class="card-item__status"
            >
            <div
              class="card-item__status item ternal"
            [ngClass]="{
              approve: data.internalReviewState === EStateAsset.APPROVED,
              reject: data.internalReviewState === EStateAsset.REJECTED
            }"
            [matTooltip]="
              !!data.internalReviewState
                ? 'Internal ' + statusMapping[data.internalReviewState]
                : 'Internal Pending'
            "
            ></div>
            <div
              class="card-item__status item"
            [ngClass]="{
              approve: data.clientReviewState === EStateAsset.APPROVED,
              reject: data.clientReviewState === EStateAsset.REJECTED
            }"
            [matTooltip]="
              data.clientReviewState === EStateAsset.APPROVED
                ? 'External Approved'
                : data.clientReviewState === EStateAsset.REJECTED
                ? 'External Rejected'
                : 'External Pending'
            "
            ></div>
          </div>
        }
        @if (!showExternalStatus && !!statusMapping[data.status!]) {
          <div
            class="card-item__status-text"
          [ngClass]="{
            approved:
              data.status === EStateAsset.APPROVED ||
              data.status == EStateAsset.COMPLETE,
            'in-review':
              data.status === EStateAsset.IN_REVIEW ||
              data.status == EStateAsset.OUT_DATED,
            rejected: data.status === EStateAsset.REJECTED,
            'in-progress':
              dataType == 'outputAssets' &&
              data.status === EStateAsset.APPROVED &&
              !data.released
          }"
          [matTooltip]="
            dataType == 'outputAssets' &&
            data.status === EStateAsset.APPROVED &&
            !data.released
              ? 'Pending Release'
              : ''
          "
            [matTooltipDisabled]="data.released"
            >
            {{
            data.status == EStateAsset.APPROVED && !authService.hasPermission(Permission.PostAssetsPreRelease)
            ? "Complete"
            : data.released
            ? "Released"
            : statusMapping[data.status!]
            }}
          </div>
        }
        <div class="card-item__spacer"></div>
        <div>
          @if (data.id) {
            <button
              mat-icon-button
              [disabled]="!data.thumbnailUri || data.label == 'Non-Select'"
              (click)="onEdit()"
            [matTooltip]="
              data.label == 'Non-Select'
                ? 'Cannot Review Non-Select'
                : 'Asset review'
            "
              >
              <mat-icon>rate_review</mat-icon>
            </button>
          }
          @if (
            (!!data.id ||
            (data.masterSuiteTouchAssetId && data.productTouchId) ||
            data.postAssetId) &&
            authService.hasPermission(Permission.PostAssetsPreRelease)
            ) {
            <button
              [matMenuTriggerFor]="actionsMenu"
              mat-icon-button
              matTooltip="More"
              color="primary"
              class="mat-elevation-z0"
              >
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu #actionsMenu="matMenu">
            @if (!!data.id) {
              <a
                (click)="getLinkDownload()"
                mat-menu-item
                [disabled]="!data.id"
                download
                >Download Asset</a
                >
              }
              @if (dataType == 'outputAssets' && !!data.postAssetId) {
                <button
                  mat-menu-item
                  (click)="fileInput.click()"
                  >
                  <span>Upload New</span>
                </button>
              }
              @if (dataType == 'postProduction' && data.shootAssetId && authService.hasPermission(Permission.PostAssetsUpload)) {
                <button
                  mat-menu-item
                  (click)="openAssetUploadDialog('post')"
                  >
                  <span>Upload Post Asset</span>
                </button>
              }
              @if (dataType == 'production' && data.productTouchAssetId && authService.hasPermission(Permission.ShootAssetsFull)) {
                <button
                  mat-menu-item
                  (click)="openAssetUploadDialog('shoot')"
                  >
                  <span>Upload Shoot Asset</span>
                </button>
              }
            </mat-menu>
          </div>
        }
      </div>
    </mat-card-actions>
  </mat-card>
